import service from './request.js';
import BASE_URL from './api.js';
// 获取个人信息
export function memberDetail() { 
    return service.get(`${BASE_URL}/member/detail`)
}
